import { jsxs, jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { getTestLabels } from '../../../utils/getTestLabels.js';
import { Icon } from '../../Icon.js';
import style from './TextBadge.module.scss.js';

const { componentTestLabel } = getTestLabels('TextBadge');
/**
 * [design (Figma)](https://www.figma.com/design/MUnGlxUUspXSbRkFsEXWGQ/%F0%9F%92%A0-Core-Components?node-id=4886-4440&t=IruA6WPg8EkG99wC-0)
 * | [source code](https://src.private.zooplus.net/projects/FE/repos/ui-components/browse/src/components/Badge/TextBadge/TextBadge.tsx)
 *
 * @param {ReactNode} icon - (optional) Should be an SVG icon from the [@zooplus/icons](https://icons.private.zooplus.net/) package.
 * @param {string} label - The badge text
 * @param {('small' | 'medium')} size - (optional) Controls the size (height) of the badge. Can be one of `small` or `medium` (defaults to `medium`).
 * @param {('info' | 'negative' | 'neutral' | 'positive' | 'warning')} variant - (optional) Controls the color/style of the badge. Can be one of `info`, `negative`, `neutral`, `positive` or `warning` (defaults to `neutral`).
 */
const TextBadge = forwardRef((props, ref) => {
    const { className, label, size = 'medium', variant = 'neutral', icon, ...otherProps } = props;
    return (jsxs("span", { "data-zta": componentTestLabel, ref: ref, className: classNames(className, style['z-text-badge'], {
            [style[`z-text-badge--size-${size}`]]: size !== 'medium',
            [style[`z-text-badge--variant-${variant}`]]: variant !== 'neutral',
        }), ...otherProps, children: [icon && (jsx(Icon, { className: classNames(style['z-text-badge__icon']), "aria-hidden": true, children: icon })), jsx("span", { className: style['z-text-badge__label'], children: label })] }));
});
TextBadge.displayName = 'TextBadge';

export { TextBadge };
//# sourceMappingURL=TextBadge.js.map
